import React, { useState } from 'react';
import { Outlet, Link, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import './Layout.css';

const Layout = () => {
  const { user, logout } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();
  const [sidebarOpen, setSidebarOpen] = useState(true);

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  const navItems = [
    { path: '/dashboard', label: 'Dashboard', icon: '📊' },
    { path: '/users', label: 'Users', icon: '👤', adminOnly: true },
    { path: '/employees', label: 'Employees', icon: '👥' },
    { path: '/salaries', label: 'Salaries', icon: '💰' },
    { path: '/leaves', label: 'Leaves', icon: '📅' },
    { path: '/overtime', label: 'Overtime', icon: '⏱', adminOrManager: true },
    { path: '/projects', label: 'Projects', icon: '📁' },
    { path: '/invoices', label: 'Invoices', icon: '📄' },
    { path: '/inventory', label: 'Inventory', icon: '💻' }
  ];

  return (
    <div className="layout">
      <aside className={`sidebar ${sidebarOpen ? 'open' : 'closed'}`}>
        <div className="sidebar-header">
          <img src="/fullLogo.png" alt="Roonbash" className="sidebar-logo" />
        </div>
        <nav className="sidebar-nav">
          {navItems.map(item => {
            if (item.adminOnly && user?.role !== 'admin') return null;
            if (item.adminOrManager && user?.role !== 'admin' && user?.role !== 'manager') return null;
            return (
              <Link
                key={item.path}
                to={item.path}
                className={`nav-item ${location.pathname === item.path ? 'active' : ''}`}
              >
                <span className="nav-icon">{item.icon}</span>
                {sidebarOpen && <span className="nav-label">{item.label}</span>}
              </Link>
            );
          })}
        </nav>
      </aside>

      <div className="main-content">
        <header className="header">
          <button
            className="sidebar-toggle"
            onClick={() => setSidebarOpen(!sidebarOpen)}
          >
            {sidebarOpen ? '◀' : '▶'}
          </button>
          <div className="header-right">
            <span className="user-name">Welcome, {user?.name}</span>
            <button className="btn btn-secondary" onClick={handleLogout}>
              Logout
            </button>
          </div>
        </header>

        <main className="content">
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default Layout;
